import { c as _c } from "react/compiler-runtime";
import { ContentSummaryProps } from "common/components/ContentSummary";
import dynamic from "next/dynamic";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { EditPageProps } from "pages/edit/index.page";
import { MostReadView } from "./MostRead.view";
const MostReadEdit = dynamic<MostReadProps>(() => import("modules/editor/blocks/MostRead/MostRead.edit").then(mod => mod.MostReadEdit));
export interface MostReadProps {
  contentSummaries?: ContentSummaryProps[];
  regionCode?: string;
  filterByCommissioningRegion?: boolean;
  language?: string;
  pageSlug?: string;
}
export const MostRead = props => {
  "use memo";

  const $ = _c(3);
  const {
    editing
  } = usePageProps();
  const MostReadComponent = editing ? MostReadEdit : MostReadView;
  let t0;
  if ($[0] !== MostReadComponent || $[1] !== props) {
    t0 = <MostReadComponent {...props} />;
    $[0] = MostReadComponent;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};